<template>
  <div class="tuolele-main-box combo-group">
    <div class="tuolele-main-search">
      <el-tabs
        v-model="search.type"
        class="tll-tab-pane"
        @tab-click="handleClick"
      >
        <el-tab-pane label="托乐乐" name="1" />
        <el-tab-pane label="天天陪读" name="2" />
      </el-tabs>
      <el-row type="flex" justify="space-between">
        <el-form :inline="true" :model="search">
          <el-form-item label="适用范围">
            <el-select v-model="search.apply_to" @change="getList">
              <el-option label="全部" value="" />
              <el-option label="前端" value="1" />
              <el-option label="后端" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="el-button-confirm"
              @click="handleGroup('add')"
            >添加分组</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <div class="tuolele-main-content">
      <el-table :data="tableData" border stripe>
        <el-table-column prop="team_name" label="分组" />
        <el-table-column prop="item_num" label="套餐数量" />
        <el-table-column
          prop="apply_to_text"
          label="适用范围"
        />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleGroup('edit', scope.row)"
            >编辑分组</el-button>
            <el-button
              type="text"
              @click="editCombo(scope.row)"
            >编辑套餐</el-button>
            <el-button
              type="text"
              class="el-button--delete"
              @click="deleteGroup(scope.row)"
            >删除分组</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加分组" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="team">
        <el-form-item label="分组名称">
          <el-input
            v-model="team.team_name"
            style="width:200px"
            placeholder="请输入分组名称"
          />
        </el-form-item>
        <el-form-item label="适用范围">
          <el-checkbox-group v-model="team.apply_to">
            <el-checkbox label="1" name="apply_to">前端</el-checkbox>
            <el-checkbox label="2" name="apply_to">后端</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div>
          注：前端人员指销售系统使用，后端人员指托乐乐系统或天天陪读系统使用
        </div>
        <el-form-item style="margin-top:20px;text-align:right">
          <el-button type="primary" @click="submit">保存</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ComboGroup',
  data() {
    return {
      dialogVisible: false,
      search: {
        type: '1',
        apply_to: ''
      },
      team: {
        team_name: '',
        apply_to: [],
        type: ''
      },
      tableData: [],
      handleGroupType: ''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.$http.getItemTeamList(this.search).then(res => {
        this.tableData = res.data.list
      })
    },
    handleClick(val) {
      this.search.type = val.name
      this.getList(this.search)
    },
    handleGroup(type, row) {
      this.dialogVisible = true
      this.handleGroupType = type
      if (type == 'add') {
        this.team = {
          team_name: '',
          apply_to: [],
          type: this.search.type
        }
      } else {
        this.team = {
          team_id: row.team_id,
          team_name: row.team_name,
          apply_to: row.apply_to.split(','),
          type: this.search.type
        }
      }
    },
    editCombo(row) {
      this.$router.push({
        path: 'editGroup',
        query: { team_id: row.team_id }
      })
    },
    deleteGroup(row) {
      this.$confirm('删除分组后，店铺将无法再使用组内套餐？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.delItemTeam({ team_id: row.team_id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getList()
        })
      })
    },
    submit() {
      if (!this.team.team_name) {
        this.$message({
          type: 'warning',
          message: '请输入分组名称'
        })
        return
      }
      if (this.team.apply_to.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择适用范围'
        })
        return
      }
      this.team.apply_to = this.team.apply_to.join(',')
      if (this.handleGroupType == 'add') {
        this.$http.addItemTeam(this.team).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.dialogVisible = false
          this.getList()
        })
      } else {
        this.$http.editItemTeam(this.team).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.dialogVisible = false
          this.getList()
        })
      }
    }
  }
}
</script>
<style lang="scss" scope>
.combo-group {
  .tuolele-main-search {
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333;
    }
    .el-form-item__content {
      margin: 0 20px 0 12px;
    }
  }
}
</style>
